import { Box } from '@mui/material';
import Component from './styled';

export default function EmptyContent() {
  return (
    <Component>
      <Box />
    </Component>
  );
}
